import React from 'react';

export const Corridor: React.FC = () => {
    return <>&nbsp;</>;
};
